import { render, staticRenderFns } from "./injuryStatus.vue?vue&type=template&id=95d4cfea&"
import script from "./injuryStatus.vue?vue&type=script&lang=js&"
export * from "./injuryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports